// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".video-ctn {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.video-ctn video {\n  width: auto;\n  height: auto;\n  max-width: 90%;\n  max-height: 90%;\n}\n", ""]);
// Exports
module.exports = exports;
